module.exports = __webpack_public_path__ + "img/financial-analysis-logo.968cb9b8.svg";